"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _components = require("@quarkly/components");

var _widgets = require("@quarkly/widgets");

var _resizeObserver = _interopRequireDefault(require("@react-hook/resize-observer"));

var _props = require("./props");

var _utils = require("../utils");

var _ComponentNotice = _interopRequireDefault(require("../ComponentNotice"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Collapse = function Collapse(_ref) {
  var minDuration = _ref.minDuration,
      maxDuration = _ref.maxDuration,
      animFunction = _ref.animFunction,
      props = _objectWithoutProperties(_ref, ["minDuration", "maxDuration", "animFunction"]);

  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides),
      override = _useOverrides.override,
      children = _useOverrides.children,
      rest = _useOverrides.rest;

  var contentRef = (0, _react.useRef)(null);
  var timerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({
    isOpen: false,
    isLock: false,
    realHeight: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      isOpen = _useState2$.isOpen,
      isLock = _useState2$.isLock,
      realHeight = _useState2$.realHeight,
      setParams = _useState2[1];

  var isEmpty = (0, _react.useMemo)(function () {
    return (0, _utils.isEmptyChildren)(children);
  }, [children]);
  (0, _react.useEffect)(function () {
    setParams(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isLock: false
      });
    });
  }, [isEmpty]);
  (0, _resizeObserver["default"])(contentRef, function (entry) {
    clearTimeout(timerRef.current);
    setParams(function (state) {
      var _entry$borderBoxSize$;

      return _objectSpread(_objectSpread({}, state), {}, {
        realHeight: entry === null || entry === void 0 ? void 0 : (_entry$borderBoxSize$ = entry.borderBoxSize[0]) === null || _entry$borderBoxSize$ === void 0 ? void 0 : _entry$borderBoxSize$.blockSize
      });
    });
  });

  var _useMemo = (0, _react.useMemo)(function () {
    var newDuration = parseFloat(minDuration) + realHeight / 4000;
    var newHeight = isOpen && !isEmpty ? realHeight : 0;

    if (newDuration > maxDuration) {
      newDuration = maxDuration;
    }

    if (isEmpty) {
      newHeight = 'auto';
    }

    var newTransition = isOpen ? "max-height ".concat(newDuration, "s ").concat(animFunction, " 0s,\nvisibility 0s ").concat(animFunction, " 0s,\nopacity ").concat(newDuration, "s ").concat(animFunction, " 0s") : "max-height ".concat(newDuration, "s ").concat(animFunction, " 0s,\nvisibility 0s ").concat(animFunction, " ").concat(newDuration, "s,\nopacity ").concat(newDuration, "s ").concat(animFunction, " 0s");
    return [newHeight, newTransition, newDuration];
  }, [minDuration, realHeight, animFunction, isOpen, isEmpty, maxDuration]),
      _useMemo2 = _slicedToArray(_useMemo, 3),
      height = _useMemo2[0],
      transition = _useMemo2[1],
      duration = _useMemo2[2];

  var updateParams = (0, _react.useCallback)(function (_ref2) {
    var open = _ref2.open;
    if (isLock) return;
    setParams(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: open,
        isLock: true
      });
    });
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(function () {
      setParams(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLock: false
        });
      });
    }, duration * 1000);
  }, [isLock, duration]);
  var toggleOpen = (0, _react.useCallback)(function () {
    updateParams({
      open: !isOpen
    });
  }, [isOpen, updateParams]);
  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    padding: "8px",
    border: "1px solid --color-lightD2",
    "border-radius": "4px"
  }, rest), /*#__PURE__*/_react["default"].createElement(_widgets.Button, _extends({}, override('Button'), {
    onPointerDown: toggleOpen,
    disabled: isEmpty
  })), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Wrapper', "Wrapper ".concat(isOpen ? ':open' : ':close')), {
    "max-height": height,
    transition: transition
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Content'), {
    ref: contentRef
  }), children), isEmpty && /*#__PURE__*/_react["default"].createElement(_ComponentNotice["default"], {
    message: "Drag any component here"
  })));
};

Object.assign(Collapse, {
  title: 'Collapse',
  description: {
    en: 'This component allows you to collapse the content smoothly',
    ru: 'Компонент для плавного переключания видимости содержимого с изменением высоты'
  },
  overrides: _props.overrides,
  propInfo: _props.propInfo,
  defaultProps: _props.defaultProps
});
var _default = Collapse;
exports["default"] = _default;